/*
  ATHLO+ — lightweight QR renderer  →  window.HubQR
  ===========================================================================
  Renders a scannable QR for a member's PUBLIC profile URL so athletes can scan
  each other's phones at events. Kept deliberately tiny: no bundled encoder, no
  build step. It draws the code with a public QR image service and ONLY ever
  passes the already-public profile URL (no personal data) — with a visible
  copy-link fallback if the image can't load (offline / blocked).

  API
    HubQR.render(el, text, { size })   -> paints a branded QR into `el`
                                          returns true if a code was drawn
  Swap-in note: to go fully self-hosted later, replace src() with a bundled
  encoder (e.g. qrcode-generator) — the render contract stays the same.
*/
(function () {
  'use strict';
  function src(text, size) {
    var s = Math.max(120, Math.min(1000, size || 240));
    // margin + dark/light tuned to ATHLO+ (near-black on white for scan reliability)
    return 'https://api.qrserver.com/v1/create-qr-code/?size=' + s + 'x' + s +
      '&margin=8&qzone=1&color=0e1116&bgcolor=ffffff&ecc=M&data=' + encodeURIComponent(text || '');
  }
  function render(el, text, opts) {
    if (!el) return false;
    opts = opts || {};
    el.textContent = '';
    if (!text) return false;
    var img = new Image();
    img.width = img.height = opts.size || 200;
    img.alt = 'QR code linking to this athlete profile';
    img.decoding = 'async'; img.loading = 'lazy';
    img.referrerPolicy = 'no-referrer';
    img.style.display = 'block';
    img.style.borderRadius = '12px';
    img.style.background = '#fff';
    img.onerror = function () {
      el.textContent = '';
      var a = document.createElement('a');
      a.href = text; a.textContent = 'Open profile link';
      a.className = 'lk-qr__fallback'; a.rel = 'noopener';
      el.appendChild(a);
    };
    img.src = src(text, (opts.size || 200) * 2); // 2× for crispness
    el.appendChild(img);
    return true;
  }
  window.HubQR = { render: render };
})();
